<template>
  <div class="ceo-page" :class="{ 'ceo-page--en': !isAr }">
    <section class="aboutCEO">
      <b-container fluid>
        <b-row class="intro-section justify-content-around">
          <b-col
            xl="6"
            lg="12"
            md="12"
            class="ceo-intro-col d-flex align-items-center"
          >
            <div class="text-section">
              <div>
                <h1 class="mb-3"><b>{{ langDec.ceo_page_intro_title }}</b></h1>
                <p>{{ langDec.ceo_page_intro_subtitle }}</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="ceo">
      <b-container fluid>
        <!-- نفس عرض بطاقات greyBox (90%) حتى تتوافق الحواف مع «الدرجة العلمية» -->
        <div class="ceo-profile-shell">
          <b-row class="justify-content-around align-items-center">
            <b-col
              xl="8"
              lg="8"
              md="12"
              class="ceo-main-text d-flex align-items-center"
            >
              <div class="text-section">
                <div>
                  <div class="title">
                    <span class="title-green">{{ langDec.about_founder_label }}</span>
                    <h2 class="name">
                      {{ langDec.about_founder_name }}
                    </h2>
                    <span class="pref">{{ langDec.about_founder_role }}</span>
                  </div>
                  <p class="ceo-lead">
                    {{ langDec.about_founder_bio }}
                  </p>
                </div>
              </div>
            </b-col>
            <b-col
              xl="4"
              lg="4"
              md="12"
              class="ceo-photo-col d-flex justify-content-center align-items-center"
            >
              <div class="img-section">
                <img
                  width="250"
                  height="250"
                  src="../assets/images/ceoPhoto.png"
                  alt=""
                >
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </section>

    <section class="greyBox">
      <b-container fluid>
        <b-row class="justify-content-around">
          <b-col xl="12" lg="12" md="12" class="ceo-grey-outer d-flex align-items-center justify-content-center">
            <div class="text-section">
              <div class="ceo-grey-inner">
                <div class="title mb-4">
                  <span class="title-green"><b>{{ langDec.ceo_section_degrees }}</b></span>
                </div>
                <b-row>
                  <b-col
                    v-for="(line, idx) in ceoLines('ceo_degrees_items')"
                    :key="'deg-' + idx"
                    xl="6"
                    lg="6"
                    md="12"
                  >
                    <p>{{ line }}</p>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="greyBox">
      <b-container fluid>
        <b-row class="justify-content-around">
          <b-col xl="12" lg="12" md="12" class="ceo-grey-outer d-flex align-items-center justify-content-center">
            <div class="text-section">
              <div class="ceo-grey-inner">
                <div class="title mb-4">
                  <span class="title-green"><b>{{ langDec.ceo_section_memberships }}</b></span>
                </div>
                <b-row>
                  <b-col
                    v-for="(line, idx) in ceoLines('ceo_memberships_items')"
                    :key="'mem-' + idx"
                    xl="6"
                    lg="6"
                    md="12"
                  >
                    <p>{{ line }}</p>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="greyBox">
      <b-container fluid>
        <b-row class="justify-content-around">
          <b-col xl="12" lg="12" md="12" class="ceo-grey-outer d-flex align-items-center justify-content-center">
            <div class="text-section">
              <div class="ceo-grey-inner">
                <div class="title mb-4">
                  <span class="title-green"><b>{{ langDec.ceo_section_experience }}</b></span>
                </div>
                <b-row>
                  <b-col
                    v-for="(line, idx) in ceoLines('ceo_experience_items')"
                    :key="'exp-' + idx"
                    xl="6"
                    lg="6"
                    md="12"
                  >
                    <p>{{ line }}</p>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="greyBox">
      <b-container fluid>
        <b-row class="justify-content-around">
          <b-col xl="12" lg="12" md="12" class="ceo-grey-outer d-flex align-items-center justify-content-center">
            <div class="text-section">
              <div class="ceo-grey-inner">
                <div class="title mb-4">
                  <span class="title-green"><b>{{ langDec.ceo_section_publications }}</b></span>
                </div>
                <b-row>
                  <b-col
                    v-for="(line, idx) in ceoLines('ceo_publications_items')"
                    :key="'pub-' + idx"
                    xl="12"
                    lg="12"
                    md="12"
                  >
                    <p>{{ line }}</p>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="greyBox">
      <b-container fluid>
        <b-row class="justify-content-around">
          <b-col xl="12" lg="12" md="12" class="ceo-grey-outer d-flex align-items-center justify-content-center">
            <div class="text-section">
              <div class="ceo-grey-inner">
                <div class="title mb-4">
                  <span class="title-green"><b>{{ langDec.ceo_section_research }}</b></span>
                </div>
                <b-row>
                  <b-col
                    v-for="(line, idx) in ceoLines('ceo_research_items')"
                    :key="'res-' + idx"
                    xl="6"
                    lg="6"
                    md="12"
                  >
                    <p>{{ line }}</p>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="greyBox">
      <b-container fluid>
        <b-row class="justify-content-around">
          <b-col xl="12" lg="12" md="12" class="ceo-grey-outer d-flex align-items-center justify-content-center">
            <div class="text-section">
              <div class="ceo-grey-inner">
                <div class="title mb-4">
                  <span class="title-green"><b>{{ langDec.ceo_section_events }}</b></span>
                </div>
                <b-row>
                  <b-col
                    v-for="(line, idx) in ceoLines('ceo_events_items')"
                    :key="'evt-' + idx"
                    xl="6"
                    lg="6"
                    md="12"
                  >
                    <p>{{ line }}</p>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AbouCEO",
  computed: {
    ...mapGetters(["getLangData", "getlang"]),
    langDec() {
      return this.getLangData || {};
    },
    isAr() {
      return (this.getlang || "ar") === "ar";
    },
  },
  methods: {
    ceoLines(key) {
      const v = this.langDec[key];
      return Array.isArray(v) ? v : [];
    },
  },
};
</script>

<style scoped lang="scss">
.ceo-intro-col {
  margin-inline-start: auto;
}

.ceo-page--en .ceo-intro-col {
  margin-inline-start: 0;
  margin-inline-end: auto;
}

.aboutCEO .intro-section {
  background-image: url(../assets/images/heroGreenBG.png);
  background-size: cover;
  background-position: right center;
  width: auto;
  height: 350px !important;
  color: white;
}

.ceo-page--en .aboutCEO .intro-section {
  background-position: left center;
}

.aboutCEO .text-section {
  align-items: center;
  margin-inline-end: 70px;
  display: flex;
  justify-content: center;
  height: 350px !important;
}

.aboutCEO .text-section h1 {
  font-size: 40px !important;
  font-weight: bolder !important;
  color: white;
}

.aboutCEO .text-section p {
  text-align: start;
  margin-bottom: 0;
}

/* ceo — محاذاة مع بطاقات .greyBox (.text-section عرض 90%) */
.ceo {
  padding: 80px 20px;
}

.ceo-profile-shell {
  width: 90%;
  margin-inline: auto;
}

.ceo .text-section {
  display: flex;
  align-items: center;
  text-align: start;
}

.ceo-main-text {
  text-align: start;
}

.ceo-lead {
  max-width: 40rem;
}

.ceo .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.ceo .text-section .name {
  font-size: 32px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: bold;
}

.ceo .text-section .pref {
  font-size: 16px;
  color: #858585;
}

.ceo .text-section p {
  margin-top: 30px;
}

/* greyBox */
.greyBox {
  padding: 40px 20px;
}

.greyBox .text-section {
  background-color: #f5f5f5;
  display: flex;
  border-radius: 10px;
  padding: 20px 30px;
  width: 90%;
}

.ceo-grey-inner {
  width: 100%;
}

.greyBox .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.greyBox .text-section p {
  text-align: start;
}

@media (max-width: 991.98px) {
  .intro-section {
    height: 550px !important;
  }

  .aboutCEO .text-section h1 {
    font-size: 30px !important;
    font-weight: bolder !important;
  }

  .ceo-profile-shell {
    width: 80%;
  }

  .ceo .text-section {
    margin-bottom: 50px;
  }

  .greyBox .text-section {
    padding: 10px;
    width: 80%;
  }
}

@media (max-width: 767.98px) {
  .intro-section {
    height: 350px !important;
  }

  .ceo-profile-shell {
    width: 95%;
  }

  .greyBox .text-section {
    width: 95%;
  }
}
</style>
